import api from '@/modules/api/api';
import type {
  QueryV1GetTwinsDiscover,
  QueryV1GetTwinsGroups,
  QueryV2GetTwinsId,
} from '@/modules/api/requests/twins.types';

export async function apiV1GetTwinsGroups() {
  return api.get<QueryV1GetTwinsGroups>('v1', '/twins/groups');
}
apiV1GetTwinsGroups.requestKey = 'get-twins-groups';

export async function apiV1GetTwinsDiscover() {
  return api.get<QueryV1GetTwinsDiscover>('v1', '/twins/discover');
}
apiV1GetTwinsDiscover.requestKey = 'get-twins-discover';

export async function apiV2GetTwinsId(botId: string) {
  return api.get<QueryV2GetTwinsId>('v2', `/twins/${botId}`);
}
apiV2GetTwinsId.queryKey = 'v2-get-twins-id';
